import $ from 'jquery';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-supported';
import { mapbox_key, mapbox_style, theme_url } from '../utils/config';

// Local state
let $map, $mapContainer, map, popup, hoveredCluster;
let mapPointsData;

// Expose a few hooks for other modules
function setMapSize() {
  if (!map) return;
  const headerOffset = (window._ILSFA_getHeaderOffset && window._ILSFA_getHeaderOffset()) || 0;
  const jumpToOffset = (window._ILSFA_getJumpToOffset && window._ILSFA_getJumpToOffset()) || 0;

  if (!$('body').hasClass('vendor-directory')) {
    $mapContainer.height($(window).height() - headerOffset - jumpToOffset);
  } else {
    $mapContainer.height($(window).height() - headerOffset);
  }

  try { map.resize(); } catch (e) {}

  if ($mapContainer.hasClass('stuck')) {
    if (!$('body').hasClass('vendor-directory')) {
      $mapContainer.css('top', headerOffset + jumpToOffset);
    } else {
      $mapContainer.css('top', headerOffset);
    }
  } else {
    $mapContainer.css('top', '');
  }
}

function flyTo(latLng, title) {
  if ($('body').hasClass('vendor-directory')) return; // match your logic
  if (!map) return;
  map.flyTo({ center: latLng, zoom: 11 });
  setTimeout(() => popup.setLngLat(latLng).setText(title).addTo(map), 500);
}

function mapPointClick(id, e) {
  const $mapCards = document.querySelector('.cards');
  const $mapPoint = $('.map-point[data-id=' + id + ']');
  const $mapPointJS = document.querySelector('.map-point[data-id="' + id + '"]');

  // Reset & scroll
  $('.map-point').not('[data-id="' + id + '"]').removeClass('active');

  if ($(window).width() > 700) {
    window.ILSFA_scrollBody 
      ? window.ILSFA_scrollBody('#organizations')
      : $('html,body').animate({ scrollTop: $('#organizations').offset().top }, 300);
  } else {
    window.ILSFA_scrollBody 
      ? window.ILSFA_scrollBody('#map-sticky-parent')
      : $('html,body').animate({ scrollTop: $('#map-sticky-parent').offset().top }, 300);
  }

  // Scroll inside cards list
  if ($mapCards && $mapPointJS) {
    const pos = getRelativePos($mapPointJS);
    smoothScroll($mapCards, pos.top - 20, 0.5);
  }

  // Highlight & toggle details
  $('.map-point').removeClass('-hover');
  $mapPoint.addClass('-hover');

  if (!$mapPoint.hasClass('active')) {
    $mapPoint.find('a.toggler').trigger('click', e);
  } else {
    popup.setLngLat([ $mapPoint.attr('data-lng'), $mapPoint.attr('data-lat') ]).setText($mapPoint.attr('data-title')).addTo(map);
  }
}

function getRelativePos(elm) {
  const p = elm.parentNode.getBoundingClientRect();
  const c = elm.getBoundingClientRect();
  return { top: c.top - p.top + elm.parentNode.scrollTop, right: c.right - p.right, bottom: c.bottom - p.bottom, left: c.left - p.left };
}
function easeInOutQuad(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
function smoothScroll(element, to, durationSec) {
  const start = element.scrollTop, change = to - start, startTime = performance.now();
  (function anim() {
    const now = performance.now();
    const elapsed = (now - startTime) / 1000;
    const t = (elapsed / durationSec);
    element.scrollTop = start + change * easeInOutQuad(t);
    if (t < 1) window.requestAnimationFrame(anim);
  }());
}

export function initMapGL() {
  $map = $('#map');
  $mapContainer = $('.map-container');

  // vendor directory minimum height (same as before)
  if ($('body').hasClass('vendor-directory') && $map.length) $mapContainer.height(500);

  // Choose the start center/zoom (unchanged)
  const start = $('body').is('vendor-directory', 'job-training', 'grassroots-education')
    ? { center: [-87.6568088, 41.8909229], zoom: 11.5 }
    : { center: [-89.185000, 40.053333], zoom: 5.5 };

  mapboxgl.accessToken = mapbox_key;

  map = new mapboxgl.Map({
    container: 'map',
    scrollZoom: false,
    center: start.center,
    zoom: start.zoom,
    ...( $('body').hasClass('vendor-directory') ? { maxZoom: start.zoom } : { minZoom: start.zoom } ),
    style: mapbox_style,
    fadeDuration: 0,
  });

  // Expose hooks for other modules
  window._ILSFA_setMapSize = setMapSize;
  window._ILSFA_flyTo = flyTo;

  const nav = new mapboxgl.NavigationControl();
  map.addControl(nav, 'top-left');

  // --- Scroll page when GL zoom controls are used (parity with your UX) ---
  (function attachZoomScrollHandlersGL(m) {
    // the zoom buttons are in the map container once control is added
    const root = m.getContainer();

    // helper to match your scroll destinations
    const scrollToContext = () => {
      if (window.innerWidth > 700) {
        if (window.ILSFA_scrollBody) {
          window.ILSFA_scrollBody('#organizations');
        } else {
          $('html,body').animate({ scrollTop: $('#organizations').offset().top }, 300);
        }
      } else {
        if (window.ILSFA_scrollBody) {
          window.ILSFA_scrollBody('#map-sticky-parent');
        } else {
          $('html,body').animate({ scrollTop: $('#map-sticky-parent').offset().top }, 300);
        }
      }
    };

    // ensure buttons exist (they are created synchronously by addControl, but guard anyway)
    const wire = () => {
      const zin  = root.querySelector('.mapboxgl-ctrl-zoom-in');
      const zout = root.querySelector('.mapboxgl-ctrl-zoom-out');
      [zin, zout].forEach(btn => {
        if (!btn || btn.__ilsfaScrollWired) return;
        btn.__ilsfaScrollWired = true;

        // Mouse / touch click → scroll (do NOT prevent default; allow map zoom)
        btn.addEventListener('click', () => { try { scrollToContext(); } catch (e) {} }, { passive: true });

        // Keyboard activation → scroll as well
        btn.addEventListener('keydown', (e) => {
          const k = e.key || e.code;
          if (k === 'Enter' || k === ' ' || k === 'Space') {
            // run after the control processes the zoom event
            setTimeout(() => { try { scrollToContext(); } catch (e2) {} }, 0);
          }
        });
      });
    };

    // try now, then again on load (some styles re-render controls)
    wire();
    m.once('load', wire);

    // if your style swaps or control re-renders later, observe container changes
    const mo = new MutationObserver(wire);
    mo.observe(root, { childList: true, subtree: true });
  })(map);

  // Keep your control SVG injection
  $('#map .mapboxgl-ctrl-zoom-in').html('<svg class="icon icon-plus" aria-hidden="true" role="presentation"><use xlink:href="#icon-plus"/></svg>').addClass('mapboxgl-ctrl-icon');
  $('#map .mapboxgl-ctrl-zoom-out').html('<svg class="icon icon-minus" aria-hidden="true" role="presentation"><use xlink:href="#icon-minus"/></svg>').addClass('mapboxgl-ctrl-icon');

  // Build features from DOM (unchanged)
  const $mapPoints = $('.map-point');
  mapPointsData = { type: 'FeatureCollection', features: [] };
  $mapPoints.each(function () {
    const $t = $(this).addClass('mapped');
    if ($t.attr('data-lat')) {
      mapPointsData.features.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [parseFloat($t.attr('data-lng')), parseFloat($t.attr('data-lat'))] },
        properties: { 'marker-color': '#000000', title: $t.attr('data-title'), url: $t.attr('data-url'), id: $t.attr('data-id') }
      });
    } else {
      $t.addClass('no-coords');
    }
  });
  if (!mapPointsData.features.length) return;

  map.on('load', function () {
    // Points source + clustering (skip clusters when vendor-directory)
    map.addSource('points', {
      type: 'geojson',
      data: mapPointsData,
      ...( !$('body').hasClass('vendor-directory') ? { cluster: true, clusterMaxZoom: 14, clusterRadius: 35 } : {} ),
    });

    if (!$('body').hasClass('vendor-directory')) {
      map.addLayer({
        id: 'clusters', type: 'circle', source: 'points', filter: ['has', 'point_count'],
        paint: { 'circle-color': ['case', ['boolean', ['feature-state', 'hover'], false], '#212126', '#212126'], 'circle-radius': 20 }
      });
      map.addLayer({
        id: 'cluster-count', type: 'symbol', source: 'points', filter: ['has', 'point_count'],
        layout: { 'text-field': '{point_count_abbreviated}', 'text-font': ['Hanken Grotesk Bold','DIN Offc Pro Medium','Arial Unicode MS Bold'], 'text-size': 16 },
        paint: { 'text-color': '#ffffff' }
      });
      map.on('click', 'clusters', function (e) {
        const features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
        const clusterId = features[0].properties.cluster_id;
        map.getSource('points').getClusterExpansionZoom(clusterId, function (err, z) {
          if (err) return;
          map.easeTo({ center: features[0].geometry.coordinates, zoom: z });
        });
      });
      map.on('mouseenter', 'clusters', () => { map.getCanvas().style.cursor = 'pointer'; });
      map.on('mouseleave', 'clusters', () => { map.getCanvas().style.cursor = ''; });
    }

    map.loadImage(theme_url + '/resources/images/marker-image.png', function (error, image) {
      if (error) throw error;
      map.addImage('new-icon-map-pin', image);
    });

    map.addLayer({
      id: 'points', type: 'symbol', source: 'points',
      filter: ['!', ['has', 'point_count']],
      layout: { 'icon-image': 'new-icon-map-pin', 'icon-allow-overlap': true }
    });

    map.addLayer({
      id: 'points-hover', type: 'symbol', source: 'points',
      layout: { 'icon-image': 'icon-map-pin-hover', 'icon-allow-overlap': true },
      filter: ['==','id','']
    });

    // Popup + interactions
    popup = new mapboxgl.Popup({ closeButton: false, offset: 20 });

    map.on('click', function (e) {
      const features = map.queryRenderedFeatures(e.point, { layers: ['points','points-hover'] });
      if (features.length > 0) mapPointClick(features[0].properties.id, e);
    });

    map.on('mousemove', function (e) {
      const features = map.queryRenderedFeatures(e.point, { layers: ['points','points-hover'] });
      const clusters = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });

      if (clusters.length > 0) {
        if (hoveredCluster) map.setFeatureState({ source: 'points', id: hoveredCluster }, { hover: false });
        hoveredCluster = clusters[0].id;
        map.setFeatureState({ source: 'points', id: hoveredCluster }, { hover: true });
      } else if (hoveredCluster) {
        map.setFeatureState({ source: 'points', id: hoveredCluster }, { hover: false });
        hoveredCluster = null;
      }

      if (features.length) {
        const feature = features[0];
        map.getCanvas().style.cursor = 'pointer';
        map.setFilter('points-hover', ['==','id', feature.properties.id]);
        $('.cards li[data-id=' + feature.properties.id + ']').addClass('-hover');
        popup.setLngLat(feature.geometry.coordinates).setText(feature.properties.title).addTo(map);
      } else {
        if (clusters.length === 0) map.getCanvas().style.cursor = '';
        $('.cards li').removeClass('-hover');
        popup.remove();
        map.setFilter('points-hover', ['==','id','']);
      }
    });

    // Hover from card → pin
    $('body').on('mouseenter', '.map-point:not(.no-coords)', function () {
      const id = $(this).attr('data-id'); map.setFilter('points-hover', ['==', 'id', id]);
    }).on('mouseleave', '.map-point', function () {
      map.setFilter('points-hover', ['==', 'id', '']);
    });

    // County boundaries + labels (GL)
    const layers = map.getStyle().layers;
    let firstSymbolId;
    for (let i = 0; i < layers.length; i++) { if (layers[i].type === 'symbol') { firstSymbolId = layers[i].id; break; } }
    const borderUrl = theme_url + '/app/lib/data/IL_BNDY_County_Py_ILSFA_regions.geojson';
    map.addSource('boundaries', { type: 'geojson', data: borderUrl });
    map.addLayer({
      id: 'region-fill', type: 'fill', source: 'boundaries',
      paint: { 'fill-color': '#5062e5', 'fill-opacity': 0.2 }
    }, firstSymbolId);
    map.addLayer({
      id: 'region-boundaries', type: 'line', source: 'boundaries',
      paint: { 'line-color': '#5062e5', 'line-width': ['interpolate', ['linear'], ['zoom'], 0, 2, 10, 5] }
    }, firstSymbolId);
    map.addLayer({
      id: 'region-labels', type: 'symbol', source: 'boundaries',
      layout: {
        'text-field': ['get','COUNTY_NAM'], 'text-justify': 'center', 'text-font': ['Hanken Grotesk Bold'],
        'text-ignore-placement': false, 'text-allow-overlap': false, 'text-padding': 10, 'symbol-avoid-edges': true
      },
      paint: { 'text-color': '#1c245e' }
    }, firstSymbolId);

    // Fit bounds (preserved)
    if (mapPointsData.features.length > 1) {
      const bounds = new mapboxgl.LngLatBounds();
      const stateBounds = [[-89.2081458, 42.2531464], [-89.2529057, 37.0296995]];
      if ($('body').hasClass('vendor-directory')) {
        map.fitBounds(stateBounds, { padding: 100 });
        map.setCenter([-89.185000, 40.053333]);
      } else if ($('body').hasClass('job-training')) {
        mapPointsData.features.forEach((f) => bounds.extend(f.geometry.coordinates));
        map.fitBounds(stateBounds, { padding: 100 });
      } else if ($('body').hasClass('grassroots-education')) {
        mapPointsData.features.forEach((f) => bounds.extend(f.geometry.coordinates));
        map.fitBounds(stateBounds, { padding: 100 });
      } else {
        mapPointsData.features.forEach((f) => bounds.extend(f.geometry.coordinates));
        map.fitBounds(bounds, { padding: 100 });
      }
    } else if (mapPointsData.features[0]) {
      if ($('body').hasClass('vendor-directory') || $('body').hasClass('job-training') || $('body').hasClass('grassroots-education')) {
        map.setCenter([-89.185000, 40.053333]);
      } else {
        map.setCenter(mapPointsData.features[0].geometry.coordinates);
      }
    }

    // Re-correct anchor after zoom changes (parity with your v11 file)
    map.on('zoom', () => {
      if (!window.location.hash) return;
      try { 
        window.ILSFA_scrollHashCorrect && window.ILSFA_scrollHashCorrect(false);
      } catch (e) {}
    });

    // Initial size
    setMapSize();
  });

  // Sticky map (same offsets)
  new window.Waypoint.Sticky({
    element: $mapContainer[0],
    wrapper: '<div class="map-sticky-wrapper" />',
    handler: () => setMapSize(),
    offset: () => {
      const headerOffset = (window._ILSFA_getHeaderOffset && window._ILSFA_getHeaderOffset()) || 0;
      const jumpToOffset = (window._ILSFA_getJumpToOffset && window._ILSFA_getJumpToOffset()) || 0;
      return (!$('body').hasClass('vendor-directory')) ? (headerOffset + jumpToOffset) : headerOffset;
    }
  });

  new window.Waypoint({
    element: $('.map-column')[0],
    handler: (direction) => { $mapContainer.toggleClass('stuck-bottom', direction === 'down'); },
    offset: 'bottom-in-view',
  });
}
